import type { ReactNode } from 'react'
import React from 'react'

import { useAuth } from '@fourthwall/auth'
import { Button, ButtonGroup, ErrorPage, SuspenseFallback } from '@fourthwall/components'
import { isProduction } from '@fourthwall/utils/dist/dev'

import { MY_SHOP_PRODUCTION_URL, MY_SHOP_STAGING_URL } from '../../../../consts/myShop'
import { useCurrentShop } from '../../../Dashboard/hooks/useCurrentShop'

type Props = {
  children: ReactNode
}

export const ForbiddenShopGuard = ({ children }: Props) => {
  const { logout } = useAuth()
  const { currentShop, isUnauthorized } = useCurrentShop()

  const getUrl = () => {
    return isProduction() ? MY_SHOP_PRODUCTION_URL : MY_SHOP_STAGING_URL
  }

  if (isUnauthorized) {
    return (
      <ErrorPage
        heading="You're currently logged in on another Fourthwall site"
        description="Log out to access the admin for this site."
        actions={
          <ButtonGroup space="medium">
            <Button label="Log out" onClick={() => logout()} />
            <Button label="Return to current site" href={getUrl()} />
          </ButtonGroup>
        }
      />
    )
  }

  if (!currentShop) {
    return <SuspenseFallback />
  }

  return children
}
